module.exports = __webpack_public_path__ + "img/calendar-23.2ea74e90.svg";